/* eslint-disable camelcase */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import apolloClient from './core/backendClient/apolloClient';
import AlertMessage from './pages/layout/components/AlertMessage';
import { GeneralProvider } from './core/app-context/GeneralContext';
import MyRoutes from './core/route';
import CustomCookieConsent from './shared/components/CookieConsent';

function App() {
  return (
    <>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <GeneralProvider>
            <AlertMessage />
            <MyRoutes />
          </GeneralProvider>
        </BrowserRouter>
      </ApolloProvider>
      <CustomCookieConsent />
    </>
  );
}

export default App;
